<template>
    <div>
        <form @submit.prevent="submit" method="post">
            <LoadingApp
                :isLoading.sync="isLoading"
                :is_full_page="full_page"
            />
            <template v-for="field in login_fields">
                <c-form-group :key="field.value" class="mb-2">
                    <input
                        :type="field.value == 'email' ? 'email' : 'text'"
                        :name="`login_${field.value}`"
                        v-model="form[field.value]"
                        :style="'font-family:'+$root.$children[0].theme.font_family"
                        class="form-input form-wide"
                        :placeholder="field.label"
                        v-mask="maskRegister(form.user_cpfcnpj, field)"
                    />
                    <div v-if="submited && !$v.form[field.value].required" class="required pt-1">* Informe seu {{ loginFieldLabel(field) }}</div>
                    <div v-else-if="field.value === 'email' && submited && !$v.form.email.email" class="required">* Informe um email válido</div>
                    <div v-else-if="$v.form[field.value].$error && !$v.form[field.value].minLength" class="required">* Informe um {{ loginFieldLabel(field) }} válido</div>
                </c-form-group>
            </template>

            <c-form-group class="mb-2">
                <input
                    type="password"
                    name="login_password"
                    :style="'font-family:'+$root.$children[0].theme.font_family"
                    v-model="form.password"
                    class="form-input form-wide"
                    placeholder="Senha"
                />
                <div v-if="submited && !$v.form.password.required" class="required pt-1">* Informe sua senha</div>
            </c-form-group>

            <div v-if="submited && message" class="required">{{message}}</div>
            <div class="form-footer">
                <c-button
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    type="submit"
                    margin="0px 3rem 0px 0px"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    height="unset"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing=".1rem"
                    transition="all .3s"
                >
                    Entrar
                </c-button>
                <c-link :href="$baseUrl+'forget-password'" :style="'font-family:'+$root.$children[0].theme.font_family" class="forget-pass"> Esqueceu sua senha?</c-link>
            </div>
        </form>

        <ModalApp name="modal_terms" style="overflow-y: auto;">
            <div class="modal-body">
                <c-heading-2>Política de Privacidade</c-heading-2>
                <div style="font-size:16px;">
                    <c-span>Ao acessar o site você concorda com os nossos</c-span>
                    <c-link style="font-size:16px; font-weight: 600;" class="btn-link" target="_blank" :href="$baseUrl+'page/politica-privacidade'">Termos de Uso e Políticas de Privacidade,</c-link>
                    <c-span>de acordo o art. 7º, inciso I, da Lei Geral de Proteção de Dados nº 13.709/2018.</c-span>
                </div>
            </div>
            <div class="modal-footer float-right">
                <c-button
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    margin="0px 3rem 0px 0px"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    height="unset"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing=".1rem"
                    transition="all .3s"
                    @click="acceptTerms"
                >
                    Aceitar
                </c-button>
            </div>
        </ModalApp>
    </div>
</template>

<script>
import { required, requiredIf, email, minLength } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import LoadingApp from '../LoadingApp'
import { CButton } from '../Styles/Button/styled'
import ModalApp from '../ModalApp.vue'
import { CFormGroup, CHeading2, CLink, CSpan } from '../Styles/Components/styled'

export default {
    name: 'Login',
    components: {
        LoadingApp,
        'c-button': CButton,
        ModalApp,
        'c-link': CLink,
        'c-heading-2': CHeading2,
        'c-form-group': CFormGroup,
        'c-span': CSpan
    },
    props: {
        modal: { required:true },
        modal_name: { default:null, type:String },
        url_previous: { default:null },
        host: { default:null }
    },
    data() {
        return {
            isLoading: false,
            submited: false,
            full_page: this.modal ? false : true,
            form: {
                email: null,
                user_cpfcnpj: null,
                password: null
            },
            message: null,
            accepted_terms: false
        }
    },
    validations: {
        form: {
            email: {
                required: requiredIf(function () {
                    return this.login_fields.some(f => f.value === 'email');
                }),
                email
            },
            user_cpfcnpj: {
                required: requiredIf(function () {
                    return this.login_fields.some(f => f.value === 'user_cpfcnpj');
                }),
                minLength: minLength(14)
            },
            password: { required }
        }
    },
    methods: {
        ...mapActions("clients", [
            "ActionGetClient",
            "ActionAuthenticate",
            "ActionLogout",
            "ActionAcceptTerms"
        ]),
        async modalAcceptTerms() {
            this.$root.showModalApp('modal_terms')
            this.isLoading = false
            await this.ActionLogout()
                .then(response => {
                })
                .catch(error => {
                })
            return
        },
        async acceptTerms() {
            this.accepted_terms = true
            await this.submit()
        },
        async confirmAcceptTerms() {
            await this.ActionAcceptTerms()
            .then(response => {
                if (response.error){
                    console.log(error)
                }
            })
            .catch(error => {
                console.log({ error })
            })
            this.continuePage()
        },
        async continuePage() {
            if(this.modal) {
                this.submited = false
                this.isLoading = false
                await this.ActionGetClient()
                this.$root.closeModalApp(this.modal_name)
                return
            }
            if(!this.url_previous) {
                window.location.href = this.$baseUrl
                return
            }
            if(this.url_previous == this.host+this.$baseUrl+'cart') {
                window.location.href = this.$baseUrl+'checkout'
                return
            }
            if(this.url_previous) {
                window.location.href = this.url_previous
                return
            }
        },
        async submit() {
            this.submited = true
            this.isLoading = true
            if (this.$v.$invalid) {
                this.isLoading = false
                this.$v.form.$touch()
                return
            }
            await this.ActionAuthenticate(this.form)
            .then(async (response) => {
                if (!response.accept_terms) {
                    if(this.accepted_terms) {
                        return await this.confirmAcceptTerms()
                    }
                    return this.modalAcceptTerms()
                }
                this.continuePage()
            })
            .catch((error) => {
                this.isLoading = false
                if(error.msg) {
                    this.message = error.msg
                    return
                }
                alert(error)
            })
        },
        maskRegister(cpf_cnpj, field) {
            if(field.label == 'CPF') {
                return "###.###.###-##";
            }
            if(field.label == 'CNPJ') {
                return "##.###.###/####-##";
            }
            if(field.value == 'user_cpfcnpj') {
                if (!cpf_cnpj || cpf_cnpj.length <= 14) {
                    return "###.###.###-##";
                }
                return "##.###.###/####-##";
            }
            return ''
        },
        loginFieldLabel(field) {
            return field.value == 'email' ? field.label.toLowerCase() : field.label;
        }
    },
    computed: {
        ...mapGetters("company", ["login_fields"])
    }
}
</script>
